<template>
  <v-ons-page id="urgences" class="l-content">
    <custom-toolbar backLabel="Retour">{{ region.name }}</custom-toolbar>

    <div class="container">
      <!-- <v-ons-button modifier="large" @click="view(KeyholdingContracts);">
        <i class="fas fa-file-contract"></i>
        Contrat
        <i class="fas fa-file-contract absoluteIcon"></i></v-ons-button> -->
      <v-ons-button modifier="large" @click="view(KeyholdingContact);">
        <i class="fas fa-phone"></i>
        Contact
        <i class="fas fa-phone absoluteIcon"></i>
      </v-ons-button>
      <v-ons-button modifier="large" @click="view(KeyholdingBrochures);" v-if="keyholding_data[region.key].brochures[$i18n.locale]">
        <i class="fas fa-map"></i>
        {{ $t("Brochures") }}
        <i class="fas fa-map absoluteIcon"></i>
      </v-ons-button>
    </div>
  </v-ons-page>
</template>

<script>
import KeyholdingBrochures from './KeyholdingBrochures.vue';
import KeyholdingContact from './KeyholdingContact.vue';
import keyholding_data from '../data/keyholding.js';

export default {
  data() {
    return {
      keyholding_data: keyholding_data,
      KeyholdingBrochures: KeyholdingBrochures,
      KeyholdingContact: KeyholdingContact,
    };
  },
  methods: {
    view(page) {
      self = this;
      this.$store.commit('navigator/push', {
        extends: page,
        data() {
          return {
            keyholding: self.keyholding_data[self.region.key]
          };
        }
      });
    }
  },
};
</script>


// WEBPACK FOOTER //
// KeyholdingRegion.vue?4ce09ac6